import React from 'react';
import { makeStyles } from '@material-ui/core';
import { reduxForm, Form, InjectedFormProps } from 'redux-form';
import { Button, FieldPercent } from 'components/Base';
import Fields from 'components/Fields';
import { compose } from 'ramda';
import { unFormatPercent } from 'utils';

const useStyles = makeStyles({
  form: {
    marginTop: '2rem',
    width: '500px',
    borderRadius: '8px'
  },
  fieldWrapper: {
    padding: '0 1rem'
  },
  btnContainer: {
    padding: '1rem',
    marginTop: '2rem',
    width: '100%'
  },
  addClientBtn: {
    width: '100%',
    paddingTop: '6px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignContent: 'space-between',
    padding: '1rem'
  },
  addClientContainer: {
    width: '100%',
    paddingTop: '24px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'space-between'
  },
  addClientInput: {
    width: '38%',
    marginRight: '12px'
  },
  addClient: {
    cursor: 'pointer',
    borderRadius: '5px',
    '& span': {
      fontSize: '0.7rem'
    }
  },
  saveCancelBtn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '24px'
  }
});

interface FixedBenchmarkProps {
  closeModal: Function;
  addFixedBenchmark: Function;
}

const FixedBenchmark = ({
  handleSubmit,
  submitting,
  closeModal,
  addFixedBenchmark
}: InjectedFormProps & FixedBenchmarkProps) => {
  const classes = useStyles();

  const onSubmit = (values: any) => {
    const annualIncrease = Number(
      unFormatPercent(values.annual_increase) / 100
    );

    addFixedBenchmark({
      active: true,
      annual_increase: annualIncrease,
      benchmark_id: null
    });
    closeModal();
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
      <div className={classes.fieldWrapper}>
        <FieldPercent
          name="annual_increase"
          component={Fields.Text}
          placeholder="0.00%"
          validate={[Fields.Validators.isPercentageValid]}
          label="Fixed % p.a. increase"
          clearfieldinform="fixedBenchmark"
        />
      </div>
      <div className={classes.saveCancelBtn}>
        <Button color="primary" onClick={() => closeModal()}>
          Cancel
        </Button>
        <Button isLoading={submitting} type="submit">
          Save
        </Button>
      </div>
    </Form>
  );
};

export default compose(
  reduxForm({
    form: 'fixedBenchmark'
  })
)(FixedBenchmark);
